import React from 'react';
import { useTranslation } from 'react-i18next';
import { cn } from '../../lib/utils';
import Segmented from '../ui/segmented';

/**
 * A project's three places: Tasks · Docs · Chats, each with its count. Underlined
 * tabs on wider screens, a segmented switch across the screen on phones.
 */
const ProjectTabs = ({ tab, onTab, counts }) => {
  const { t } = useTranslation();
  const items = [
    { key: 'tasks', label: t('projects.table_tasks') },
    { key: 'docs', label: t('projects.documents') },
    { key: 'chats', label: t('bots.chat.chats_title') },
  ];
  const count = (key) => (counts[key] > 0 ? counts[key] : null);
  return (
    <>
      <div role="tablist" className="hidden md:flex items-end gap-6 border-b border-border" data-testid="project-tabs">
        {items.map(({ key, label }) => (
          <button key={key} type="button" role="tab" aria-selected={tab === key} onClick={() => onTab(key)}
            data-testid={`project-tab-${key}`}
            className={cn('h-9 -mb-px px-0.5 inline-flex items-center gap-1.5 border-b-2 text-sm transition-colors',
              tab === key ? 'border-amber-500 text-foreground font-medium' : 'border-transparent text-muted-foreground hover:text-foreground')}>
            {label}
            {count(key) != null && <span className="font-normal text-muted-foreground tabular-nums">{count(key)}</span>}
          </button>
        ))}
      </div>
      <Segmented className="md:hidden" fill size="lg" value={tab} onChange={onTab}
        items={items.map(({ key, label }) => ({ key, label, count: count(key) }))} />
    </>
  );
};

export default ProjectTabs;
